<template>
  <v-list>
    <v-list-group :value="standardFunctionBlockEnabled">
      <template v-slot:activator>
        <v-list-item-title>Standard Function Blocks</v-list-item-title>
      </template>

      <v-list-item v-for="pou in pous.standardFunctionBlocks" :key="`pou_${pou.id}`">
        <v-list-item-title :id="`pou_${pou.id}`">
          {{
          pou.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group :value="additionalFunctionBlockEnabled">
      <template v-slot:activator>
        <v-list-item-title>Additional Function Blocks</v-list-item-title>
      </template>

      <v-list-item v-for="pou in pous.additionalFunctionBlocks" :key="`pou_${pou.id}`">
        <v-list-item-title :id="`pou_${pou.id}`">
          {{
          pou.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group :value="typeConversionEnabled">
      <template v-slot:activator>
        <v-list-item-title>Type conversion</v-list-item-title>
      </template>

      <v-list-item v-for="pou in pous.typeConversions" :key="`pou_${pou.id}`">
        <v-list-item-title :id="`pou_${pou.id}`">
          {{
          pou.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group :value="numericalEnabled">
      <template v-slot:activator>
        <v-list-item-title>Numerical</v-list-item-title>
      </template>

      <v-list-item v-for="pou in pous.numerical" :key="`pou_${pou.id}`">
        <v-list-item-title :id="`pou_${pou.id}`">
          {{
          pou.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group :value="arithmeticEnabled">
      <template v-slot:activator>
        <v-list-item-title>Arithmetic</v-list-item-title>
      </template>

      <v-list-item v-for="pou in pous.arithmetic" :key="`pou_${pou.id}`">
        <v-list-item-title :id="`pou_${pou.id}`">
          {{
          pou.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group :value="timeEnabled">
      <template v-slot:activator>
        <v-list-item-title>Time</v-list-item-title>
      </template>

      <v-list-item v-for="pou in pous.time" :key="`pou_${pou.id}`">
        <v-list-item-title :id="`pou_${pou.id}`">
          {{
          pou.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group :value="bitShiftEnabled">
      <template v-slot:activator>
        <v-list-item-title>Bit-shift</v-list-item-title>
      </template>

      <v-list-item v-for="pou in pous.bitShift" :key="`pou_${pou.id}`">
        <v-list-item-title :id="`pou_${pou.id}`">
          {{
          pou.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group :value="bitWiseEnabled">
      <template v-slot:activator>
        <v-list-item-title>Bitwise</v-list-item-title>
      </template>

      <v-list-item v-for="pou in pous.bitWise" :key="`pou_${pou.id}`">
        <v-list-item-title :id="`pou_${pou.id}`">
          {{
          pou.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group :value="selectionEnabled">
      <template v-slot:activator>
        <v-list-item-title>Selection</v-list-item-title>
      </template>

      <v-list-item v-for="pou in pous.selection" :key="`pou_${pou.id}`">
        <v-list-item-title :id="`pou_${pou.id}`">
          {{
          pou.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group :value="comparisionEnabled">
      <template v-slot:activator>
        <v-list-item-title>Comparision</v-list-item-title>
      </template>

      <v-list-item v-for="pou in pous.comparision" :key="`pou_${pou.id}`">
        <v-list-item-title :id="`pou_${pou.id}`">
          {{
          pou.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group :value="characterStringEnabled">
      <template v-slot:activator>
        <v-list-item-title>Character String</v-list-item-title>
      </template>

      <v-list-item v-for="pou in pous.characterString" :key="`pou_${pou.id}`">
        <v-list-item-title :id="`pou_${pou.id}`">
          {{
          pou.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group v-if="userDefinedPous.length > 0" :value="userDefinedEnabled">
      <template v-slot:activator>
        <v-list-item-title>User defined POUs</v-list-item-title>
      </template>

      <v-list-item v-for="pou in userDefinedPous" :key="`pou_${pou.id}`">
        <v-list-item-title :id="`pou_${pou.id}`">
          {{
          pou.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group v-if="variables.length > 0" :value="variableEnabled">
      <template v-slot:activator>
        <v-list-item-title>Variables</v-list-item-title>
      </template>

      <v-list-item v-for="variable in variables" :key="`var_${variable}`">
        <v-list-item-title :id="`var_${variable}`">
          {{
          variable
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group :value="commonEnabled">
      <template v-slot:activator>
        <v-list-item-title>Common Elements</v-list-item-title>
      </template>

      <v-list-item v-for="commonElement in commonElements" :key="`el_${commonElement.name}}`">
        <v-list-item-title :id="`el_${commonElement.elementType}`">
          {{
          commonElement.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group v-if="pou && pou.body && ['LD', 'SFC'].includes(pou.body.language)" :value="ldEnabled">
      <template v-slot:activator>
        <v-list-item-title>LD elements</v-list-item-title>
      </template>

      <v-list-item v-for="ldElement in ldElements" :key="`ldEl_${ldElement.elementType}`">
        <v-list-item-title :id="`ldEl_${ldElement.elementType}`">
          {{
          ldElement.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>

    <v-list-group v-if="pou && pou.body && pou.body.language === 'SFC'" :value="sfcEnabled">
      <template v-slot:activator>
        <v-list-item-title>SFC elements</v-list-item-title>
      </template>

      <v-list-item v-for="sfcElement in sfcElements" :key="`sfcEl_${sfcElement.elementType}`">
        <v-list-item-title :id="`sfcEl_${sfcElement.elementType}`">
          {{
          sfcElement.name
          }}
        </v-list-item-title>
      </v-list-item>
    </v-list-group>
  </v-list>
</template>

<script>
import { filter, find, map } from "lodash";
import uuid from "src/mixins/uuid";
import ldElements from "./ldElements.json";
import sfcElements from "./sfcElements.json";
import commonElements from "./commonElements.json";

export default {
  props: ["pouTempId"],
  mixins: [uuid],
  data() {
    return {
      commonEnabled: true,
      standardFunctionBlockEnabled: true,
      additionalFunctionBlockEnabled: true,
      typeConversionEnabled: true,
      numericalEnabled: true,
      arithmeticEnabled: true,
      timeEnabled: true,
      bitShiftEnabled: true,
      bitWiseEnabled: true,
      selectionEnabled: true,
      comparisionEnabled: true,
      characterStringEnabled: true,
      userDefinedEnabled: true,
      variableEnabled: true,
      ldEnabled: true,
      sfcEnabled: true,

      commonElements,
      ldElements,
      sfcElements,
    };
  },
  mounted() {
    setTimeout(() => {
      this.commonEnabled = false;
      this.standardFunctionBlockEnabled = false;
      this.additionalFunctionBlockEnabled = false;
      this.typeConversionEnabled = false;
      this.numericalEnabled = false;
      this.arithmeticEnabled = false;
      this.timeEnabled = false;
      this.bitShiftEnabled = false;
      this.bitWiseEnabled = false;
      this.selectionEnabled = false;
      this.comparisionEnabled = false;
      this.characterStringEnabled = false;
      this.userDefinedEnabled = false;
      this.variableEnabled = false;
      this.ldEnabled = false;
      this.sfcEnabled = false;
    }, 10);
  },
  computed: {
    pou() {
      return find(this.$store.state.pous, { tempId: this.pouTempId });
    },
    pous() {
      return this.$store.state.commonPous;
    },
    userDefinedPous() {
      const pou = find(this.$store.state.pous, { tempId: this.pouTempId });

      const userDefinedPous = filter(this.$store.state.pous, (availPou) => {
        if (availPou.pouType === "program") {
          return false;
        }

        if (availPou.tempId === this.pouTempId) {
          return false;
        }

        if (
          pou.pouType === "function" &&
          availPou.pouType === "functionBlock"
        ) {
          return false;
        }

        return true;
      });

      return map(userDefinedPous, (pou) => ({ id: pou.name, name: pou.name }));
    },
    variables() {
      const excludedDerivedNames = map(
        this.$store.state.commonPous.standardFunctionBlocks,
        "name"
      );
      const pou = find(this.$store.state.pous, {
        tempId: this.pouTempId,
      });

      const variables = filter(
        pou.variables,
        (variable) =>
          !excludedDerivedNames.includes(variable?.type?.derivedName)
      );

      return map(variables, "name");
    },
  },
};
</script>

